/* eslint-disable */
import React, { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import RemoveIcon from 'assets/icons/remove-icon'
import ConfirmIcon from 'assets/icons/confirm-icon'
import RejectIcon from 'assets/icons/reject-icon'
import AssessIcon from 'assets/icons/assess-icon'
import ReassessIcon from 'assets/icons/reassess-icon'
import PulsingNotification from 'features/PulsingNotification'
import CancelIcon from 'assets/icons/cancel-icon16px'
import { SiteContext } from 'providers/site'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { SITE_STATUS_DRAFT_ID, SITE_STATUS_NOMINATED_ID } from 'constants/siteStatuses'
import { ProfileContext } from 'providers/profile'
import { SECRETARIAT_ROLE_ID, BIRDLIFE_SECRETARIAT_ROLE_ID } from 'constants/roles'
import ActionsMenu from 'features/ActionMenu'
import { confirmCriterionE, cancelCriterionEReassessmentRequest } from 'api/criterionE'
import Tooltip from 'components/Tooltip'
import Button from 'components/Button'
import Modal from 'components/Modal'
import FlowRequestModal from 'components/FlowRequestModal'
import CalendarIcon from 'assets/icons/calendar-icon'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'
import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import { INDIVIDUAL_ROLE_ID } from 'constants/roles'
import { showErrorToast } from 'utils/toast'

import {
  EcosystemActionMenuWrapper,
  EcosystemCalendarDateText, EcosystemCalendarDivider, EcosystemCalendarIconWrapper,
  EcosystemConfirmDeclineIcon,
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarIconWrapper,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle, EcosystemLastReassessmentCalendarWrapper, EcosystemToggleWrapper,
  EcoSystemValidationIcon, EcosystemValidationIconWrapper, EcosystemsCancelIconWrapper
} from '../EcosystemData/style'

const formattedRejectIconTooltipHint = (item) => {
  return item.trigger_reason_id.map((element) => {
    return reassessmentTriggerReasons.find((elementId) => {
      return elementId.id === Number(element)
    }).name
  })
}


const tooltipXOffset = 0
const tooltipYOffset = -16
const dateOptions = {
  year: "numeric",
  month: "short",
  weekday: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: true // This is the line of code we care about here
  /*
      false: displays 24hs format for time
      true: displays 12, AM and PM format
  */
};
const criterionEAccordionHeader = ({ isOpen, item, openRemoveCriterionEModal, getCriterionEs, toggleAccordion, lastItem, newTriggers = false, oldTriggers = false }) => {
  const { site, siteProposalFieldValidation, isEditable } = useContext(SiteContext)
  const { profile } = useContext(ProfileContext)
  const isIndividualUser = profile.Role.id === INDIVIDUAL_ROLE_ID
  const dateToShow = item.updated_at ? new Date(item.updated_at) : new Date()
  const [isCancelOpen, setIsCancelOpen] = useState(false)
  const [criterionEToCancel, setCriterionEToCancel] = useState(null)

  const handleCriterionEAction = async (isApproved) => {
    await confirmCriterionE(item.site_irreplaceability_history_id || item.site_irreplaceability_id, isApproved)
    getCriterionEs()
  }

  const actionMenuItems = item.is_approved_by_secretariat ? [{
    icon: <RejectIcon />,
    title: 'rejectCriterionE',
    onClick: async () => {
      await handleCriterionEAction({ isApproved: false })
    },
    isDestructive: true
  }] : [{
    icon: <ConfirmIcon />,
    title: 'confirmCriterionE',
    onClick: async () => {
      await handleCriterionEAction({ isApproved: true })
    }
  }]

  const validationCriterionE = siteProposalFieldValidation.criterionE[item.site_irreplaceability_history_id || item.site_irreplaceability_id]
    ? siteProposalFieldValidation.criterionE[item.site_irreplaceability_history_id || item.site_irreplaceability_id]
    : defaultSiteProposalValidationResults.criterionE

  const fieldsToCompleteNumber = Object.values(validationCriterionE).filter((element) => {
    return element === false
  })

  const qulifyes = item.trigger_reason_id?.some((element) => {
    // eslint-disable-next-line no-magic-numbers
    return Number(element) === 1
  })

  const cancelCriterionEsChanges = async (criterionE) => {
    if (!isIndividualUser) {
      showErrorToast('This action is not allowed.')
      return
    }
    const data = await cancelCriterionEReassessmentRequest({ siteId: site.historyId, criterionEId: criterionE.site_irreplaceability_history_id, isCancelled: true })
    if (data.error) {
      return showErrorToast(data.error)
    }
    setIsCancelOpen(false)
    setCriterionEToCancel(null)
    toggleAccordion()
    await getCriterionEs()
  }

  const disabled = site.SiteStatusId !== SITE_STATUS_DRAFT_ID || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID) || !qulifyes

  return (
    <>
      <EcosystemHeaderNavbarWrapper
        isOpen={isOpen}
        bottomBorder={isOpen || lastItem}
        data-testid='criterionE'
      >
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon isRejected={!qulifyes} />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle
            isRejected={!qulifyes}
            data-testid='criterionE-name'
            isReassess={item.last_reassessment_date}
          >
            {item?.year}
          </EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide>
          {site.reassessmentFlag ? (
            <>
              {dateToShow !== '' && (
                <Tooltip
                  style={{ zIndex: 1000 }}
                  placement='top'
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{ label: 'lastTimeReassessed' }}
                >

                  <EcosystemLastReassessmentCalendarWrapper>
                    <EcosystemCalendarIconWrapper>
                      <CalendarIcon />
                    </EcosystemCalendarIconWrapper>
                    <EcosystemCalendarDateText>
                      {dateToShow.toLocaleDateString('en-US', dateOptions)}
                    </EcosystemCalendarDateText>
                    <EcosystemCalendarDivider />
                  </EcosystemLastReassessmentCalendarWrapper>

                </Tooltip>
              )}
              <EcosystemConfirmDeclineIcon type={qulifyes ? 'confirmed' : 'rejected'}>
                {qulifyes ? (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'qualifies' }}
                  >
                    <div>
                      <ConfirmIcon />
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(item).join(', ') }}
                  >
                    <div>
                      <RejectIcon />
                    </div>
                  </Tooltip>
                )}
              </EcosystemConfirmDeclineIcon>
              {site.SiteStatusId === SITE_STATUS_DRAFT_ID ? (
                <>
                  <Button
                    isDisabled={isOpen}
                    type={isOpen ? 'defaultDisabled' : ' '}
                    height='32px'
                    marginTop='0'
                    onClick={toggleAccordion}>
                    <ReassessIcon />
                    <FormattedMessage id={oldTriggers ? 'reassess' : newTriggers ? 'assess' : 'reassess'} />
                  </Button>

                  {oldTriggers && <EcosystemsCancelIconWrapper onClick={(e) => {
                    e.stopPropagation()
                    setCriterionEToCancel(item)
                    setIsCancelOpen(true)
                  }}>
                    <CancelIcon />
                  </EcosystemsCancelIconWrapper>
                  }
                </>
              ) : (
                <>
                  <EcosystemToggleWrapper isActive={isOpen} onClick={toggleAccordion}>
                    <FormattedMessage id='expand' />
                    {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
                  </EcosystemToggleWrapper>
                </>
              )}
              {(!item.last_reassessment_date && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !disabled) && (
                <>
                  <EcosystemHeaderNavbarIconWrapper
                    delete={true}
                    data-testid='remove-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      openRemoveCriterionEModal(item)
                    }}
                  >
                    <RemoveIcon />
                  </EcosystemHeaderNavbarIconWrapper>
                </>
              )}
              {fieldsToCompleteNumber.length > 0 && (
                <EcosystemValidationIconWrapper>
                  <EcoSystemValidationIcon>
                    <PulsingNotification number={fieldsToCompleteNumber.length} />
                  </EcoSystemValidationIcon>
                </EcosystemValidationIconWrapper>
              )}
            </>
          ) : (
            <>
              <>
                {site.SiteStatusId === SITE_STATUS_DRAFT_ID ? (
                  <Button
                    height='32px'
                    onClick={toggleAccordion}
                    marginTop='0'
                    isDisabled={isOpen}
                    type={isOpen ? 'defaultDisabled' : ''}
                  >
                    <AssessIcon />
                    <FormattedMessage id={oldTriggers ? 'reassess' : newTriggers ? 'assess' : 'reassess'} />
                  </Button>
                ) : (
                  <>
                    {dateToShow !== '' && (
                      <Tooltip
                        style={{ zIndex: 1000 }}
                        placement='top'
                        trigger={['hover']}
                        align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                        overlay={{ label: 'lastTimeReassessed' }}
                      >

                        <EcosystemLastReassessmentCalendarWrapper>
                          <EcosystemCalendarIconWrapper>
                            <CalendarIcon />
                          </EcosystemCalendarIconWrapper>
                          <EcosystemCalendarDateText>
                            {dateToShow.toLocaleDateString('en-US', dateOptions)}
                          </EcosystemCalendarDateText>
                          <EcosystemCalendarDivider />
                        </EcosystemLastReassessmentCalendarWrapper>

                      </Tooltip>
                    )}
                    <EcosystemConfirmDeclineIcon type={qulifyes ? 'confirmed' : 'rejected'}>
                      {qulifyes ? (
                        <Tooltip
                          style={{ zIndex: 1000 }}
                          placement='top'
                          trigger={['hover']}
                          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                          overlay={{ label: 'qualifies' }}
                        >
                          <div>
                            <ConfirmIcon />
                          </div>
                        </Tooltip>
                      ) : (
                        <Tooltip
                          style={{ zIndex: 1000 }}
                          placement='top'
                          trigger={['hover']}
                          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                          overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(item).join(', ') }}
                        >
                          <div>
                            <RejectIcon />
                          </div>
                        </Tooltip>
                      )}
                    </EcosystemConfirmDeclineIcon>
                    <EcosystemToggleWrapper isActive={isOpen} onClick={toggleAccordion}>
                      <FormattedMessage id='expand' />
                      {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
                    </EcosystemToggleWrapper>
                  </>
                )}
              </>
              {site.SiteStatusId === SITE_STATUS_DRAFT_ID && !disabled && (
                <>
                  <EcosystemHeaderNavbarIconWrapper
                    data-testid='remove-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      openRemoveCriterionEModal(item)
                    }}
                  >
                    <RemoveIcon />
                  </EcosystemHeaderNavbarIconWrapper>
                </>
              )}
              {(site.SiteStatusId === SITE_STATUS_NOMINATED_ID && (profile.RoleId === SECRETARIAT_ROLE_ID || profile.RoleId === BIRDLIFE_SECRETARIAT_ROLE_ID)) &&
                <EcosystemActionMenuWrapper>
                  <ActionsMenu table={false} dropdownItems={actionMenuItems} margin='0' />
                </EcosystemActionMenuWrapper>
              }
              {fieldsToCompleteNumber.length > 0 && (
                <EcosystemValidationIconWrapper>
                  <EcoSystemValidationIcon>
                    <PulsingNotification number={fieldsToCompleteNumber.length} />
                  </EcoSystemValidationIcon>
                </EcosystemValidationIconWrapper>
              )}
            </>
          )}
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
      <Modal
        width='416px'
        isOpen={isCancelOpen}
        toggleModal={setIsCancelOpen}
        modalTitleId='cancelCriterionEReassessment'
      >
        <FlowRequestModal
          cancelHandler={() => {
            setIsCancelOpen(false)
            setCriterionEToCancel(null)
          }}
          confirmHandler={() => {
            cancelCriterionEsChanges(criterionEToCancel)
          }}
          confirmBtnText='yesCancel'
          rejectBtnText='continueEditing'
          text={<FormattedMessage id='returnDiscardCriterionEChangesText' values={{ year: <b>{criterionEToCancel?.year}</b> }} />}
          item={criterionEToCancel}
          approve={true}
        />
      </Modal>
    </>
  )
}

export default criterionEAccordionHeader